import {JsonProperty} from '../shared/decorators/json-property';

export class AffiliateTotal {
  @JsonProperty('total_lot')
  totalLot: number;
  @JsonProperty('affiliate_return')
  affiliateReturn: number;
  @JsonProperty('total_ib')
  totalIb: number;
  @JsonProperty('direct')
  direct: number;
  @JsonProperty('precede_v1')
  precede_v1: number;
  @JsonProperty('precede_v2')
  precede_v2: number;
  @JsonProperty('total_sub_ib_reward')
  total_sub_ib_reward: number;

  constructor() {
    this.totalLot = undefined;
    this.affiliateReturn = undefined;
    this.totalIb = undefined;
    this.direct = undefined;
    this.precede_v1 = undefined;
    this.precede_v2 = undefined;
    this.total_sub_ib_reward = undefined;
  }
}

export class AffiliateUserData {
  @JsonProperty('total_lot')
  totalLot: number;
  @JsonProperty('affiliate_return')
  affiliateReturn: number;
  balance: number;
  credit: number;
  deposit: number;
  constructor() {
    this.totalLot = undefined;
    this.affiliateReturn = undefined;
    this.balance = undefined;
    this.credit = undefined;
    this.deposit = undefined;
  }
}
export class RankingModel {
  @JsonProperty('id')
  id: number;
  @JsonProperty('keep')
  keep: number;
  @JsonProperty('name')
  name: number;
  @JsonProperty('current_volume')
  current_volume: number;
  @JsonProperty('expire_date')
  expire_date: number;
  constructor() {
    this.id = undefined;
    this.keep = undefined;
    this.current_volume = undefined;
    this.name=undefined;
    this.expire_date=undefined
  }
}
export class Affiliate {
  @JsonProperty('user_id')
  userId: number;
  @JsonProperty('ib_id')
  ibID: number;
  active: number;
  email: string;
  level: number;
  @JsonProperty('fun_transfer')
  funTransfer: number;
  @JsonProperty('total_user')
  totalUser: number;
  @JsonProperty('user_data')
  userData: AffiliateUserData;
  @JsonProperty('total_ib')
  totalIb: number;
  @JsonProperty('total_earning')
  totalEarning: AffiliateTotal;
  @JsonProperty('ib_data')
  ibData: AffiliateTotal;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('first_name_jp')
  firstNameJP: string;
  @JsonProperty('last_name_jp')
  lastNameJP: string;
  @JsonProperty('kyc_status')
  kyc: number;
  @JsonProperty('total_asset')
  totalAsset: number;
  @JsonProperty('parent_id')
  parentId: number;
  @JsonProperty('total_trader_lot')
  totalLot: number;
  @JsonProperty('total_balance')
  totalBalance: number;
  @JsonProperty('total_deposit')
  totalDeposit: number;
  @JsonProperty('total_withdraw')
  totalWithdraw: number;
  @JsonProperty('currency')
  currency: string;
  @JsonProperty('ranking')
  ranking: RankingModel;
  @JsonProperty('type')
  type: number;
  isExpand: boolean;
  @JsonProperty('kyc_status')
  kycStatus: number;
  constructor() {
    this.active = undefined;
    this.userId = undefined;
    this.level = undefined;
    this.email = undefined;
    this.totalUser = undefined;
    this.userData = new AffiliateUserData();
    this.totalIb = undefined;
    this.totalEarning = new AffiliateTotal();
    this.ibData = new AffiliateTotal();
    this.firstName = undefined;
    this.middleName = undefined;
    this.lastName = undefined;
    this.ibID = undefined;
    this.firstNameJP = undefined;
    this.lastNameJP = undefined;
    this.kyc = undefined;
    this.totalAsset = undefined;
    this.parentId = undefined;
    this.totalLot = undefined;
    this.funTransfer = undefined;
    this.totalBalance = undefined;
    this.totalDeposit = undefined;
    this.totalWithdraw = undefined;
    this.currency = undefined;
    this.ranking=new RankingModel();
    this.type = undefined;
    this.isExpand = undefined;
    this.kycStatus = undefined;
  }
  getUsername(): string {
    return this.firstName + ' ' + this.lastName;
  }
  getUsernameJP(): string {
    return ((this.firstNameJP) ? this.firstNameJP : '') + ' ' + ((this.lastNameJP) ? this.lastNameJP : '');
  }
  getKYC(): string {
    switch (this.kyc) {
      case -1:
        return '<span class="text-muted">Unuploaded</span>';
      case 0:
        return '<span class="text-primary">Uploaded</span>';
      case 1:
        return '<span class="text-green">Verified</span>';
      case 2:
        return '<span class="text-red">Rejected</span>';
    }
  }
  getTextKYC(): string {
    switch (this.kyc) {
      case -1:
        return 'Unuploaded';
      case 0:
        return 'Uploaded';
      case 1:
        return 'Verified';
      case 2:
        return 'Rejected';
    }
  }
}

export class RankSettingItem {
  @JsonProperty('min_volume')
  min: number;
  @JsonProperty('max_volume')
  max: number;
  @JsonProperty('t1_rate')
  t1: number;
  @JsonProperty('t2_rate')
  t2: number;
  constructor() {
    this.min = undefined;
    this.max = undefined;
    this.t1 = undefined;
    this.t2 = undefined;
  }
}

export class RankSetting {
  @JsonProperty({ clazz: RankSettingItem, name: 'standard' })
  standard: RankSettingItem;
  @JsonProperty({ clazz: RankSettingItem, name: 'silver' })
  silver: RankSettingItem;
  @JsonProperty({ clazz: RankSettingItem, name: 'gold' })
  gold: RankSettingItem;
  constructor() {
    this.standard = undefined;
    this.silver = undefined;
    this.gold = undefined;
  }
}

